import React, { useEffect, useState } from "react";

import styles from "./Select.module.scss";

// alternative select, supports search filter (modified clone of Select)

/**
 *
 * @param {String} [icon] - fa className icon to add at the start of the dropdown-toggle
 * @param {Array} [options] - options to choose from
 * @param {Array} [children] - children to render instead of options
 * @param {Boolean} [posAbsolute] - whether the dropdown-menu should use position absolute; default is true
 * @param {Function} onClick - function to run when clicking on option; use to alter state in parent component and pass down value
 * @param {String} value - value "selected" and shown in dropdown-toggle
 * @param {Object} [labels] - labels for values that require the text shown to be different from the value
 * @param {Object} [dropdownToggleRef] - ref to trigger dropdown-menu close from parent (checkout /maintain/users/edit)
 * @param {String} [placeholder] - placeholder
 * @param {Boolean} [multiple] - whether to allow multiselect
 * @param {String} [size] - md/lg; default is lg
 * @param {Boolean} [disabled] - disables select; default is false
 */
const SelectAlt = props => {
    const {
        // icon,
        labels,
        // options,
        children,
        onClick,
        setState,
        value,
        dropdownToggleRef,
        placeholder,
        disabled = false,
        showAll = true,
    } = props;
    const size = props.size || "lg";
    const [showDropdown, setShowDropdown] = useState(false);
    const [searchValue, setSearchValue] = useState("");
    const [searchList, setSearchList] = useState(children);

    useEffect(() => {
        setSearchValue(value);
    }, [value]);

    useEffect(() => {
        if (!showAll) {
            setSearchList(children);
        }
    }, [children]);

    const toggleDropdown = e => {
        if (!disabled) {
            setShowDropdown(!showDropdown);
        }
    };

    // const _icon = props.icon ? <i className={props.icon} /> : null;
    // const _value = (labels && labels[value]) || value;
    // const _valueClass = value === "" || value === false ? styles.placeholder : "";

    const className = `${styles["dropdown-toggle"]} ${showDropdown ? "show" : "hide"} ${styles[`select-${size}`]} ${disabled ? styles.disabled : ""}`;
    const menuClass = `${styles["dropdown-menu"]} ${showDropdown ? "" : styles.hidden} ${styles[`select-${size}`]}`;

    const handleClick = (e) => {
        if (!disabled && labels[e.target.dataset.id]) {
            setSearchValue(labels[e.target.dataset.id]);
            onClick(e);
            toggleDropdown(e);
            // setSearchList(children); // reset list on select
        }
    };

    const handleSearch = (e) => {
        try {
            setShowDropdown(true);
            setSearchValue(e.target.value);
            const search = children.filter(item => {
                if (item.props && item.props.children) {
                    return item.props.children.toLowerCase().includes(e.target.value.toLowerCase())
                }
            });
            setSearchList(search);
            setState && setState((s) => ({
                ...s,
                state: e.target.value,
                state_name: e.target.value,
            }));
        } catch (error) {
            console.log('error', error);
        }
    }
    return (
        <div className={styles.dropdown}>
            <div className={className} onClick={toggleDropdown} ref={dropdownToggleRef}>
                {/* {_icon} */}
                <input placeholder={placeholder} autoComplete="none" className={styles.input} value={searchValue || ""} onChange={handleSearch} />
                <i className="fas fa-sort-down" />
            </div>
            <menu className={menuClass} onMouseUp={handleClick}>
                {searchList}
            </menu>
        </div>
    );
};

export default SelectAlt;
